import { buildHash } from '@/client/services/update/constants'
import { datadogLogs } from '@datadog/browser-logs'

let initializedDatadogLogs = false
export function getDatadogLogs(): typeof datadogLogs {
  if (!initializedDatadogLogs) {
    datadogLogs.init({
      clientToken: 'pubd77dbabac129b15726e8384f66586195',
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sampleRate: 100,
      service: 'webapp-browser',
      version: buildHash ?? undefined,
    })
    initializedDatadogLogs = true
  }

  return datadogLogs
}

export function getDatadogLogger(
  level: 'debug' | 'info' | 'warn' | 'error'
): typeof datadogLogs.logger {
  return getDatadogLogs().createLogger('webapp', { level })
}
